import type { DocumentView, StatementOption } from '../../types';
import { getSuggestedCodes } from '../getSuggestedCodes';
import { rankStatement } from '../toDocumentViews';

// Pre-select only when the strongest evidence tier names exactly one code, and only a
// statement carrying that code — otherwise the modal would propose a formulation the
// best evidence contradicts. Contradictions are the reviewer's call.
export const getPreselectedStatement = (documents: DocumentView[]): StatementOption | undefined => {
    const codes = getSuggestedCodes(documents);

    if (codes.length !== 1) {
        return undefined;
    }

    return documents
        .flatMap(document => document.statements)
        .filter(option => option.isSelectable && option.suggestedCode?.toUpperCase() === codes[0])
        .sort((first, second) => rankStatement(second) - rankStatement(first))[0];
};
